import { cn } from "@workspace/web-ui/lib/utils";

interface PatientAvatarProps {
    initials: string;
    className?: string;
}

export const PatientAvatar = ({ initials, className }: PatientAvatarProps) => {
    return (
        <div
            className={cn("flex p-2 sm:p-3 rounded-full items-center justify-center text-white text-xs sm:text-sm font-medium shimmer-card", className)}
            style={{ backgroundColor: "#7F8493" }}
        >
            {initials}
        </div>
    );
}; 